/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-07 10:46:30
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import {
  getTIManagementDetailAsync,
  getTIManagementSubmitAsync,
} from './TIManagementSlice'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from '../../../models/datetime'
import { getUserList } from '../../user/userSlice'
import { GenderOptions, getGenderName } from '../../../models/user'
const { Option } = Select

export const AddOrEditFormModal = (props: {
  editTenantId?: any
  id?: any
  isEdit?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const [userList, setUserList] = useState<any>()

  const [id, setId] = useState<any>()

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 17 },
  }

  const layouts = {
    labelCol: { span: 2 },
    wrapperCol: { span: 21 },
  }
  const getDetail = () => {
    dispatch(
      getTIManagementDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
          startTime: v?.startTime ? moment(v?.startTime) : '',
          endTime: v?.endTime ? moment(v?.endTime) : '',
        })
      })
  }
  useEffect(() => {
    if (props.isModalVisible) {
      dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
        .then(unwrapResult)
        .then((res: any) => {
          setUserList(res?.items)
        })
    }
  }, [props.isModalVisible])

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      }
    } else {
      form.resetFields()
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={1000}
        title={
          props?.isEdit == '0'
            ? '查看详情'
            : props?.id
            ? '编辑数据'
            : '添加数据'
        }
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            const startTime = vs?.startTime
              ? moment(vs?.startTime)?.format(DateTimeFormat)
              : ''

            const endTime = vs?.endTime
              ? moment(vs?.endTime)?.format(DateTimeFormat)
              : ''

            setConfirmLoading(true)
            const params = props?.id
              ? {
                  ...detail,
                  ...vs,
                  id: detail?.id,
                }
              : {
                  ...vs,
                }
            dispatch(
              getTIManagementSubmitAsync({
                ...params,
                startTime: startTime,
                endTime: endTime,
              })
            )
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={8}>
              <Form.Item {...layout} label='培训类别' name='trainingCategory'>
                <Input placeholder='培训类别' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='培训方式' name='trainingWay'>
                <Input placeholder='培训方式' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='培训地点'
                name='trainingLocation'
                rules={[{ required: true, message: '培训地点不能为空' }]}
              >
                <Input placeholder='培训地点' />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item {...layout} label='主办单位' name='sponsorUnit'>
                <Input placeholder='主办单位' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='讲课人' name='lecturer'>
                <Input placeholder='讲课人' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='证书名称' name='certificateName'>
                <Input placeholder='证书名称' />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item {...layout} label='证书编号' name='certificateNumber'>
                <Input placeholder='证书编号' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='开始时间'
                name='startTime'
                rules={[{ required: true, message: '开始时间不能为空' }]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='开始时间'
                  showTime
                  format={DateTimeFormat}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='结束时间'
                name='endTime'
                rules={[{ required: true, message: '结束时间不能为空' }]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='结束时间'
                  showTime
                  format={DateTimeFormat}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='学时'
                name='classHours'
                rules={[
                  {
                    message: '请输入最多带两位小数的数值',
                    pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                  },
                ]}
              >
                <Input placeholder='学时' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='备注' name='remark'>
                <Input placeholder='备注' maxLength={50} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...layouts} label='培训内容' name='trainingContent'>
                <Input.TextArea
                  placeholder='培训内容'
                  showCount
                  rows={3}
                  maxLength={200}
                />
              </Form.Item>
            </Col>
          </Row>
          {props?.isEdit == '0' ? (
            <></>
          ) : (
            <Row
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                loading={confirmLoading}
                type='primary'
                onClick={() => {
                  form.submit()
                }}
                style={{ marginRight: '10px' }}
              >
                确定
              </Button>
              <Button
                type='primary'
                ghost
                style={{ marginRight: '10px' }}
                onClick={() => {
                  props?.onCancel()
                }}
              >
                取消
              </Button>
            </Row>
          )}
        </Form>
      </Modal>
    </>
  )
}
